import { Table } from 'reactstrap'
import PendingByReport from './PendingByReport'

export default function QuarterlySummaryReport() {
  console.log('QuarterlySummaryReport rendered')

  return (
    <div className="custom-scroll">
      <Table style={{backgroundColor: 'white', width: 'auto', margin: 'auto'}} >
        <tbody>
          <tr>
            <td>
              <PendingByReport title={'PENDING CASES BY REJECTION REASON'} procedureName={'pending_by_rejection'} />
            </td>
            <td>
              <PendingByReport title={'PENDING CASES BY DIAGNOSIS'} procedureName={'pending_by_diagnosis'} />
            </td>
          </tr>
          <tr>
            <td>
              <PendingByReport title={'PENDING CASES BY PLAINTIFF COUNSEL'} procedureName={'pending_by_counsel'} />
            </td>
            <td>
              <PendingByReport title={'PENDING CASES BY JURISDICTION'} procedureName={'pending_by_jurisdiction'} />
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <PendingByReport title={'ALL TENDER REJECTED CASES BY YEAR AND REJECTION REASON'} procedureName={'pending_by_year'} />
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  )
}
